
class FilterTuple {
    title: string;
    id: number;
}

class NameTuple {
    id: number;
    name: string;
}

class SelectorTuple {
    value: string;
    label: string;


    static fromNameTuple(nameTuple?: NameTuple): SelectorTuple {
        const newTuple = new SelectorTuple();
        newTuple.value = "" + nameTuple.id;
        newTuple.label = nameTuple.name;

        return newTuple;
    }
}

export { FilterTuple, NameTuple, SelectorTuple };
